import type { ReactNode } from "react";
import { Button } from "./Button";
import type { ButtonProps } from "./Button";

export interface IconButtonProps extends Omit<
  ButtonProps,
  "iconOnly" | "children" | "leadingIcon"
> {
  /** The icon element to render. */
  icon: ReactNode;
  /** Accessible name — required, since there is no visible label. */
  label: string;
}

/** Square icon-only button; `label` becomes both aria-label and the native tooltip. */
export function IconButton({ icon, label, variant = "ghost", ...rest }: IconButtonProps) {
  return (
    <Button iconOnly variant={variant} aria-label={label} title={label} {...rest}>
      {icon}
    </Button>
  );
}
